export const formatCardDate = (v: string) => {
  const digits = v.replace(/\D/g, "").slice(0, 4)
  if (digits.length === 0) return ""

  let mm = digits.slice(0, 2)
  const yy = digits.slice(2, 4)

  if (mm.length === 2) {
    const n = parseInt(mm, 10)
    if (n === 0) mm = "01"
    else if (n > 12) mm = "12"
  }

  return yy.length > 0 ? `${mm}/${yy}` : mm
}
